/* jshint quotmark: false */
(function () {
	'use strict';

	angular.module('app.supplyChain')
		.directive('inventoryBurnoffChart', inventoryBurnoffChart);

	function inventoryBurnoffChart($filter, $window, $timeout, $translate,
			currencyFormatService, inventoryBurnoffService, leanFilterService,
			fullPageChart, storeService, $experiments, defaultTransitionDuration) {
		return {
			link: function (scope, elem, attr) {
				var chart;
				var initListener;
				var initListener2;
				var colors = {
					'historyLdna': '#0584E2',
					'historyMrp': '#FF6701',
					'mrp': '#FF6701',
					'ldna': '#0584E2',
					'pastDue': '#E686C8',
					'hiddenBar': '#fff',
					'netOpportunity': '#84C9FC',
					'reductionResults': '#8FCE46',
					'lostOpportunity': '#E20482'
				};
				var showTargets = true;
				var historyStartDateStr = '';
				var windowHeight = 0;
				var resizeDebounced = _.debounce(function() {
					windowHeight = fullPageChart.resizeChart('burnoffChartCont', true);
					// required to fit chart into new width
					generateChart();
				}, defaultTransitionDuration);

				function resizeChart() {
					resizeDebounced();
				}

				var hasHistoryLines = false;
				var todayXValue = undefined;

				function init() {
					var hbCont = jQuery('#handlebarContainer').length;
					var supplierPortal = globalConfig.user.role === 'Supplier';
					var gridLoaded = jQuery('#burnoffChartCont').length;
					if (globalConfig && globalConfig.factory && gridLoaded) {
						jQuery('.embeddedBody').resize(resizeChart);
						jQuery('#handlebarContainer').bind('leftNavChanged', resizeChart);
						jQuery('#navigation').bind('leftNavChanged', resizeChart);
						generateChart();
					} else {
						$timeout(function () {
							init();
						}, 10);
					}
				}
				var currentSelectedPoint = undefined;
				var chartData = {};
				var currency;
				var yAxisFieldName = 'mrpValue';
				var targetFieldName = 'ldnaTargetValue';
				var ignoredValueFieldName = 'ignoredValue';
				var xAxisField = 'periodEndDate';
				var mrpCounter = -1;
				var ldnaTargetCounter = -1;
				var visibleDataNames;

				var isV2 = $experiments.isEnabled('burnoff-v2');
				var currentActiveTab = undefined;
				var currentBarIndex = undefined;

				function labelFormat(v, id, i, j) {
					if ((id == yAxisFieldName || id == targetFieldName) && v != null) {
						var indexValue;
						if (id == yAxisFieldName) {
							mrpCounter++;
							indexValue = mrpCounter;
						} else {
							ldnaTargetCounter++;
							indexValue = ldnaTargetCounter;
						}
						if ((v || v == 0) 
							&& (
								(id === yAxisFieldName && (indexValue % 4) - 2 == 0)
								|| (id === targetFieldName && (indexValue % 4) == 0)
							)
						 ) {
							return currencyFormatService.get(v, currency);
						}
					}
				}

				function addDataLabelClasses() {
					for (var i = 0; i < chartData.length; i++) {
						if(chartData[i][yAxisFieldName] > chartData[i].ldnaTargetValue) {
							jQuery('.c3-chart-text.c3-target.c3-target-ldnaTargetValue .c3-text-' + i).addClass('c3-transform-down');
						} else if (chartData[i].ldnaTargetValue > chartData[i][yAxisFieldName]) {
							jQuery('.c3-chart-text.c3-target.c3-target-' + yAxisFieldName + ' .c3-text-' + i).addClass('c3-transform-down');
						}
					}

				}

				function getStartDateFromOptions(options, defaultWeeks) {
					var isMonthly = options.weeklyOrMonthly === 'MONTHLY';
					var startOffset = isMonthly ? 0 : -1 * (+options.past || defaultWeeks || 26);
					return inventoryBurnoffService.relDate(startOffset);
				}

				function getEndDateFromOptions(options, defaultWeeks) {
					var isMonthly = options.weeklyOrMonthly === 'MONTHLY';
					return isMonthly
						? inventoryBurnoffService.relMonthlyDate(+options.futureMonths || 12)
						: inventoryBurnoffService.relDate(+options.future || defaultWeeks || 26);
				}

				function getPosition(dataToShow, tWidth, tHeight, element) {
					// This function copied in from c3 source with a tweak to handle when overflowing right
					var $$ = this, config = $$.config, d3 = $$.d3;
					var svgLeft, tooltipLeft, tooltipRight, tooltipTop, chartRight;
					var forArc = $$.hasArcType(), mouse = d3.mouse(element);
					// Determin tooltip position
					if (forArc) {
						tooltipLeft = ($$.width - ($$.isLegendRight ? $$.getLegendWidth() : 0)) / 2 + mouse[0];
						tooltipTop = ($$.hasType('gauge') ? $$.height : $$.height / 2) + mouse[1] + 20;
					}
					else {
						svgLeft = $$.getSvgLeft(true);
						if (config.axis_rotated) {
							tooltipLeft = svgLeft + mouse[0] + 100;
							tooltipRight = tooltipLeft + tWidth;
							chartRight = $$.currentWidth - $$.getCurrentPaddingRight();
							tooltipTop = $$.x(dataToShow[0].x) + 20;
						}
						else {
							tooltipLeft = svgLeft + $$.getCurrentPaddingLeft(true) + $$.x(dataToShow[0].x) + 20;
							tooltipRight = tooltipLeft + tWidth;
							chartRight = svgLeft + $$.currentWidth - $$.getCurrentPaddingRight();
							tooltipTop = mouse[1] + 15;
						}
						if (tooltipRight > chartRight) {
							// 20 is needed for Firefox to keep tooltip width
							// tooltipLeft -= tooltipRight - chartRight + 20; 
							// XXX This is the change from original c3
							tooltipLeft = mouse[0] - tWidth + 40;
						}
						if (tooltipTop + tHeight > $$.currentHeight) {
							tooltipTop -= tHeight + 30;
						}
					}
					if (tooltipTop < 0) {
						tooltipTop = 0;
					}
					return {
						top: tooltipTop,
						left: tooltipLeft
					};
				}

				function tooltipFormat(d, defaultTitleFormat, defaultValueFormat, color) {
					var options = storeService.getState().reportSettings.config.options || {};
					var $$ = this,
						config = $$.config,
						CLASS = $$.CLASS,
						titleFormat = config.tooltip_format_title || defaultTitleFormat,
						valueFormat = config.tooltip_format_value || defaultValueFormat,
						text, i, j, title, value, name;

					var historyMrpTranslation = $translate.instant('Projected Inventory as of {date}');
					var historyLdna = $translate.instant('Potential Inventory as of {date}');

					var tooltipFields = [
						{
							id: yAxisFieldName,
							name: 'Actual or Projected',
							color: colors.mrp
						}, {
							id: 'ldnaTargetValue',
							name: 'Potential Inventory',
							color: colors.ldna
						}, {
							id: 'ignoredValue',
							name: 'Potential Inventory (no exclusions)',
							color: colors.ldna
						}, {
							id: 'historyMrp',
							name: historyMrpTranslation.replace('{date}', historyStartDateStr),
							color: colors.mrp
						}, {
							id: 'historyLdna',
							name: historyLdna.replace('{date}', historyStartDateStr),
							color: colors.ldna
						}, {
							id: 'netOpportunity',
							name:$translate.instant('Net Opportunity'),
							color: colors.netOpportunity,
							legendType: 'square'
						}, {
							id: 'overTargetValue',
							name: $translate.instant('Over Target Qty'),
							extraClass: 'nested-row'
						}, {
							id: 'underTargetValue',
							name: $translate.instant('Under Target Qty'),
							extraClass: 'nested-row'
						}, {
							id: 'pastDueReqs',
							name: $translate.instant('Past Due Requirements'),
							extraClass: 'nested-row no-extra-margin'
						}, {
							id: 'pastDuePOs',
							name: $translate.instant('Past Due Purchase Orders'),
							extraClass: 'nested-row no-extra-margin'
						}, {
							id: 'reductionResults',
							name: $translate.instant('Reduction Results'),
							legendType: 'square',
							color: colors.reductionResults
						}, {
							id: 'lostOpportunity',
							name: $translate.instant('Lost Opportunity'),
							legendType: 'square',
							color: colors.lostOpportunity
						}, {
							id: 'reductionResultsTooltipOnly',
							name: $translate.instant('Reduction Results'),
							legendType: 'square',
							color: colors.reductionResults
						}, {
							id: 'lostOpportunityTooltipOnly',
							name: $translate.instant('Lost Opportunity'),
							legendType: 'square',
							color: colors.lostOpportunity
						}
					];

					var hasPastDueValues = _.find(d, function(val) {
						return (val.id === 'pastDuereqs' || val.id === 'pastDuePOs')
							&& (val.value || val.value === 0);
					});

					var addedDividerLine = false;

					for (i = 0; i < tooltipFields.length; i++) {
						var tooltipField = tooltipFields[i];
						if ((tooltipField.id === 'ldnaTargetValue' 
							|| tooltipField.id === 'netOpportunity') && hasPastDueValues
						) {
							continue;
						}

						if (!isV2 && (tooltipField.id === 'reductionResults'
							|| tooltipField.id === 'lostOpportunity'
							|| tooltipField.id === 'reductionResultsTooltipOnly'
							|| tooltipField.id === 'lostOpportunityTooltipOnly'
						)) {
							continue;
						}

						// skip lost opportunity if data is hidden.
						// special case because data is hidden with css instead of being disabled via c3
						if (tooltipField.id.indexOf('lostOpportunity') === 0
								&& config.data_hide.indexOf('ldnaMinusLost') !== -1) {
							continue;
						} 

						var hasExtras = false;

						for (j = 0; j < d.length; j++) {
							if (!d[j] || d[j].id !== tooltipField.id) {
								// keep looking for next field
								continue;
							}

							// found field but no value, move to next field
							if (!(d[j].value || d[j].value === 0)) {
								break;
							}
							value = valueFormat(d[j].value, d[j].ratio, d[j].id, d[j].index);
							if (value === undefined) {
								break;
							}

							// initialize text
							if (!text) {
								text = '<div class="' + CLASS.tooltip + '">';
								// text = '<table class="burnoff-tooltip ' + CLASS.tooltip + '">';
								title = titleFormat ? $filter('date')(d[j].x, 'mediumDate', 'UTC') : d[j].x;
								if (title || title === 0) {
									text += '<div class="tooltip-row tooltip-date">' + title + '</div>';
									// text += '<tr><th colspan="2">' + title + '</th></tr>';
								}
							}

							name = tooltipField.name;
							var colorCode = tooltipField.color;

							// special cases
							if (d[j].id === yAxisFieldName) {
								if (d[j].x < new Date()) {
									name = 'Actual Inventory';
								} else {
									name = 'Projected Inventory';
								}
							}

							if (d[j].id === 'netOpportunity') {
								// Need to determine if it's positive or negative 
								// (the actual value has to be + to show bar in the correct location)
								// find over and under target values
								var overTargetValue = 0;
								var underTargetValue = 0;
								for (var k = 0; k < d.length; k++) {
									if (d[k].id === 'overTargetValue') {
										overTargetValue = d[k].value;
									} else if (d[k].id === 'underTargetValue') {
										underTargetValue = d[k].value;
									}
								}
								if (overTargetValue + underTargetValue < 0) {
									value = '-' + value;
								}
							}

							if (isV2
								&& !options.interactiveHistory
								&& (d[j].id === 'reductionResults'
									|| (d[j].id === 'lostOpportunity' && !addedDividerLine)
									|| (d[j].id === 'reductionResultsTooltipOnly' && !addedDividerLine)
									|| (d[j].id === 'lostOpportunityTooltipOnly' && !addedDividerLine))
							) {
								if (d[j].x <= scope.fromDate) {
									continue;
								}
								addedDividerLine = true;
								text += '<div class="divider-line"></div>';
								var fromDate = $filter('date')(scope.fromDate, 'MMM d', 'UTC');
								var secondTitle = titleFormat ? $filter('date')(d[j].x, 'mediumDate', 'UTC') : d[j].x;
								if (secondTitle || secondTitle === 0) {
									text += '<div class="tooltip-row tooltip-date">' + fromDate + ' to ' + secondTitle + '</div>';
								}
							}

							text += '<div class="tooltip-row ' + (tooltipField.extraClass ? tooltipField.extraClass : '') + '">';
							text += '<div class="row-left">';
							text += '<div class="row-color">';
							var addExtras = d[j].id === 'reductionResultsTooltipOnly' || d[j].id === 'lostOpportunityTooltipOnly';
							hasExtras = hasExtras || addExtras;
							if (tooltipField.legendType === 'square') {
								text += '<div class="square-48" style="' + (addExtras ? 'opacity: 0.5;' : '') + 'background-color:' + colorCode + '"></div>';
							} else if (tooltipField.color) {
								text += '<div class="line-48" style="border-color:' + colorCode + '"></div>';
								text += '<div class="circle-48" style="background-color:' + colorCode + '"></div>';
							}
							text += '</div>';
							text += '<div class="row-text ' + (addExtras ? 'gray-6' : '') + '">' + $translate.instant(name) + (addExtras ? '*' : '') + '</div></div>';
							text += '<div class="row-right">' + value + '</div></div>';
							break;
						}
					}
					if (hasExtras) {
						text += '<div class="tooltip-row legend">* Bars not shown when Optimized Inventory is more than Projected.</div>';
					}
					return text + '</div>';
				}

				function addFYLabels() {
					var label, label2, i, targetLineLabel;

					var chartObj = jQuery('#burnoffChartCont .c3-grid')[0];
					if (!chartObj) {
						return;
					}
					jQuery('.addedLabel').remove();

					var targetLineLabels = [
						{
							id: 'fyLine',
							lineElementClass: 'fyTargetClass',
							text: 'FY Target',
							value: scope.chartData.fyTarget,
							yPos: null
						},
						{
							id: 'stretchLine',
							lineElementClass: 'stretchTargetClass',
							text: 'Stretch Target',
							value: scope.chartData.stretchTarget,
							yPos: null
						}
					];

					var parentElem = elem[0];
					for (i = 0; i < targetLineLabels.length; i++) {
						targetLineLabel = targetLineLabels[i];

						var targetParent = parentElem.getElementsByClassName(targetLineLabel.lineElementClass)[0];
						if (!targetParent) {
							continue;
						}
						var targetLine = targetParent.getElementsByTagName('line');
						if (targetLine && targetLine.length === 1) {
							var targetLineElem = targetLine[0];
							targetLineLabel.yPos = parseInt(jQuery(targetLineElem).attr('y2'));
						}
					}
					// remove missing
					targetLineLabels = targetLineLabels.filter(function (label) {
						return label.yPos !== null && !isNaN(label.yPos);
					});

					if (targetLineLabels.length > 0) {
						spreadYPos(targetLineLabels);

						// calculate x position
						var yAxisWidth = 0;
						var yAxisObj = jQuery('#burnoffChartCont .c3-axis-y')[0];
						if (yAxisObj) {
							yAxisWidth = yAxisObj.getBoundingClientRect().width;
						}
						var chartWidth = jQuery('#burnoffChartCont .c3-grid')[0].getBoundingClientRect().width;
						var xPos = yAxisWidth + chartWidth + 16;

						// create and add labels
						for (i = 0; i < targetLineLabels.length; i++) {
							targetLineLabel = targetLineLabels[i];
							if (!targetLineLabel.value) {
								continue;
							}
							if (showTargets) {
								label = getLabelElement(xPos, targetLineLabel.yPos);
								label2 = getLabelElement(xPos, targetLineLabel.yPos + 16);

								label.textContent = targetLineLabel.text;
								label2.textContent = '(' + currencyFormatService.get(targetLineLabel.value, currency) + ')';

								jQuery(parentElem.getElementsByTagName('svg')[0]).append(label);
								jQuery(parentElem.getElementsByTagName('svg')[0]).append(label2);
							}
						}
					}
				}

				function spreadYPos(labels) {
					// determine y-positions by spreading out any labels that are too close
					var minDistanceForLabels = 32;

					labels.sort(function(line1, line2) {
						return line1.yPos - line2.yPos;
					});

					var isDistributed = false,
						loops = 0;
					while (!isDistributed && loops < 50) {
						isDistributed = true;
						loops += 1;

						var lastValue = labels[0].yPos;
						for (var i = 1; i < labels.length; i++) {
							var currentLine = labels[i];
							var gap = currentLine.yPos - lastValue;
							if (gap < minDistanceForLabels) {
								isDistributed = false;
								labels[i-1].yPos -= 2;
								currentLine.yPos += 2;
							}
							lastValue = currentLine.yPos;
						}
					}
				}

				function getLabelElement(xPos, yPos) {
					return makeSVG('text', {
						x: xPos,
						y: yPos,
						fill: '#5C9F07',
						style: 'font-size:12px',
						class: 'addedLabel'
					});
				}

				function makeSVG(tag, attrs) {
					var el = document.createElementNS('http://www.w3.org/2000/svg', tag);
					for (var k in attrs) {
						if (attrs.hasOwnProperty(k)) {
							el.setAttribute(k, attrs[k]);
						}
					}
					return el;
				}

				function getMinMaxRange(chartData, dataToHide) {
					// get max/min for different data series
					var dataSeriesNames = [yAxisFieldName, 'historyMrp', 'historyLdna', targetFieldName,
						'ignoredValue'];

					var options = storeService.getState().reportSettings.config.options || {},
						startDate = getStartDateFromOptions(options, scope.defaultWeeksPast),
						endDate = getEndDateFromOptions(options, scope.defaultWeeksFuture);
					;
					
					var i;
					if (scope.showExtraData) {
						dataSeriesNames.push('pastDueReqs');
					}
					if (chart) {
						dataSeriesNames = [];
						// only consider visible data if the chart has been drawn
						var visibleData = chart.data.shown();
						var ignoredFields = ['netOpportunity', 'reductionResults', 'hiddenBar', 'pastDuePOs',
							'lostOpportunity', 'excludedActions', 'lostOpportunityTooltipOnly',
							'reductionResultsTooltipOnly', 'unableToFixValue', 'expiredValue', 'overTargetValue',
							'underTargetValue'];
						var includeV2Fields = isV2 && !options.interactiveHistory;
						for (i = 0; i < visibleData.length; i++) {
							if (ignoredFields.indexOf(visibleData[i].id) === -1 &&
									(includeV2Fields || (visibleData[i].id !== 'mrpPlusSavings' && visibleData[i].id !== 'ldnaMinusLost')) &&
									(scope.showExtraData || visibleData[i].id !== 'pastDueReqs')) {
								dataSeriesNames.push(visibleData[i].id);
							}
						}
					} else if (dataToHide) {
						// only consider visible data if the chart has been drawn
						for (i = dataSeriesNames.length - 1; i >= 0; i--) {
							if (dataToHide.indexOf(dataSeriesNames[i]) !== -1) {
								dataSeriesNames.splice(i, 1);
							}
						}
					}
					var minAxisValue = null;
					var maxAxisValue = null;
					
					startDate.setDate(startDate.getDate() - 7);
					endDate.setDate(endDate.getDate() + 7);

					var limitedData = chartData.filter(function(val) {
						return val.periodEndDate > startDate && val.periodEndDate < endDate;
					});

					function getDataSeriesValue(d) {
						return d[dataSeriesName];
					}

					for (i = 0; i < dataSeriesNames.length; i++) {
						var dataSeriesName = dataSeriesNames[i];

						var seriesMinValue = d3.min(limitedData, getDataSeriesValue);
						var seriesMaxValue = d3.max(limitedData, getDataSeriesValue);

						if (minAxisValue === null || minAxisValue > seriesMinValue) {
							minAxisValue = seriesMinValue;
						}
						if (maxAxisValue === null || maxAxisValue < seriesMaxValue) {
							maxAxisValue = seriesMaxValue;
						}
					}

					// consider targets which are a single value
					var targetNames = ['fyTarget', 'stretchTarget'];
					for (i = 0; i < targetNames.length; i++) {
						var targetName = targetNames[i];
						if (showTargets) {
							var targetValue = scope.chartData[targetName];
							// ignore '', 0, null
							if (!targetValue) {
								continue;
							}
							if (targetValue < minAxisValue) {
								minAxisValue = targetValue;
							}
							if (targetValue > maxAxisValue) {
								maxAxisValue = targetValue;
							}
						}
					}

					var range = {
						'min': minAxisValue,
						'max': maxAxisValue
					};
					return fullPageChart.roundRangeValues(range, 6, true);
				}

				function openDetailsSlideIn(dataPoint) {
					var index = !dataPoint.x ? dataPoint.index : _.findIndex(chartData, function (pt) {
						return pt.periodEndDate === dataPoint.x;
					});
					var netOpp = currencyFormatService.get(chartData[index].netOpportunity, currency);

					var reductionResults = chartData[index].reductionResults || chartData[index].reductionResultsTooltipOnly;
					var lostOpportunity = chartData[index].lostOpportunity || chartData[index].lostOpportunityTooltipOnly;
					var reductionValue = currencyFormatService.get(reductionResults, currency);
					var lostPotentialValue = currencyFormatService.get(lostOpportunity, currency);

					var overTargetValue = chartData[index].overTargetValue;
					var underTargetValue = chartData[index].underTargetValue;
					if (overTargetValue + underTargetValue < 0) {
						netOpp = '-' + netOpp;
					}
					if (reductionResults < 0) {
						reductionValue = '-' + reductionValue;
					}
					if (lostOpportunity < 0) {
						lostPotentialValue = '-' + lostPotentialValue;
					}
					var activeTab = null;
					if (dataPoint.activeTab != null) {
						activeTab = dataPoint.activeTab;
					} else if (dataPoint.id === 'reductionResults' || dataPoint.id === 'mrpPlusSavings') {
						activeTab = 'reduction-results';
					} else if (dataPoint.id === 'lostOpportunity' || dataPoint.id === 'ldnaMinusLost') {
						activeTab = 'lost-opportunity';
					} else {
						activeTab = 'net-opportunity';
					}
					var param = {
						periodNumber: chartData[index].period,
						date: chartData[index][xAxisField],
						index: index,
						barIndex: (hasHistoryLines && dataPoint.barIndex) || dataPoint.index,
						overUnderTargetValue: netOpp,
						reductionValue: reductionValue,
						lostPotentialValue: lostPotentialValue,
						activeTab: activeTab
					};

					currentActiveTab = activeTab;
					currentBarIndex = index;
					scope.$emit('openBurnoffDrawer', param);
				}

				function findDateInDataPoints(date) {
					for (var i = 0; i < chartData.length; i++) {
						if (chartData[i].periodEndDate.getFullYear() === date.getFullYear() &&
							chartData[i].periodEndDate.getMonth() === date.getMonth() &&
							chartData[i].periodEndDate.getDate() === date.getDate()) {
							return chartData[i];
						}
					}
					return null;
				}

				function mergeHistoryToResults(historyDataPoint) {
					var historyDate = new Date(historyDataPoint.periodEndDate);
					var matchingDataPoint = findDateInDataPoints(historyDate);
					if (matchingDataPoint != null) {
						matchingDataPoint.historyLdna = historyDataPoint.ldnaTargetValue;
						matchingDataPoint.historyMrp = historyDataPoint.mrpValue;
					} else {
						var tmp = {};
						tmp.periodEndDate = historyDate;
						tmp.historyLdna = historyDataPoint.ldnaTargetValue;
						tmp.historyMrp = historyDataPoint.mrpValue;
						chartData.push(tmp);
					}
				}

				function getDefaultKeys(hasHistory) {
					// legend fields, need to be ordered
					var defaultKeys = [yAxisFieldName];
					if (isV2 && !hasHistory) {
						defaultKeys.push('mrpPlusSavings');
					}
					defaultKeys.push(targetFieldName);
					if (isV2 && !hasHistory) {
						defaultKeys.push('ldnaMinusLost');
					}
					// non-legend fields
					defaultKeys = defaultKeys.concat('pastDueReqs', 'pastDuePOs');
					if (isV2 && !hasHistory) {
						defaultKeys = defaultKeys.concat('hiddenBar', 'lostOpportunity', 'lostOpportunityTooltipOnly',
							'excludedActions', 'expiredValue', 'unableToFixValue', 'netOpportunity',
							'overTargetValue', 'underTargetValue', 'reductionResults', 'reductionResultsTooltipOnly');
					} else {
						defaultKeys = defaultKeys.concat('hiddenBar', 'netOpportunity', 'overTargetValue', 'underTargetValue');
					}
					return defaultKeys;
				}

				function getXLines() {
					var options = storeService.getState().reportSettings.config.options || {};
					var lines = [];
					if (options.weeklyOrMonthly === 'MONTHLY') {
						if (scope.fiscalQuarters && scope.fiscalQuarters.length) {
							scope.fiscalQuarters.forEach(function (qt) {
								lines.push({
									value: qt.startDateForQuarter,
									text: 'Q' + qt.fiscalQtr + ' ' + qt.fiscalYear,
									class: 'todayClass'
								});
							});
						}
					} else {
						lines.push({
							value: scope.now,
							text: 'Today',
							class: 'todayClass'
						});
					}
					return lines;
				}

				function addStartingDataPointToHistory(date) {
					var endOfDay = new Date(date).setHours(23, 59, 59, 999);
					var bestMatch;
					var indexOfBestMatch;
					for (var i = 0; i < chartData.length; i++) {
						var currentDate = chartData[i].periodEndDate;
						if (bestMatch === undefined) {
							if (currentDate < endOfDay) {
								bestMatch = currentDate;
								indexOfBestMatch = i;
							}
						} else {
							if (currentDate < endOfDay && currentDate > bestMatch) {
								bestMatch = currentDate;
								indexOfBestMatch = i;
							}
						}
					}
					chartData[indexOfBestMatch].historyLdna = chartData[indexOfBestMatch].mrpValue;
					chartData[indexOfBestMatch].historyMrp = chartData[indexOfBestMatch].mrpValue;
				}
				
				function formatCurrency(val) {
					return currencyFormatService.get(val, currency);
				}
				var unsubscribeFromStore;

				function allowPatternFill() {
					// Pattern fills svgs found here https://iros.github.io/patternfills/
					c3.chart.internal.fn.afterInit = function () {
						d3.select('defs')
							.append('pattern')
							.attr('id', 'diagonal-stripe-blue')
							.attr('patternUnits', 'userSpaceOnUse')
							.attr('width', 10)
							.attr('height', 10)
							.append('image')
							.attr('xlink:href', 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHdpZHRoPScxMCcgaGVpZ2h0PScxMCc+CiAgPHJlY3Qgd2lkdGg9JzEwJyBoZWlnaHQ9JzEwJyBmaWxsPScjODRDOUZDJy8+CiAgPHBhdGggZD0nTS0xLDEgbDIsLTIKICAgICAgICAgICBNMCwxMCBsMTAsLTEwCiAgICAgICAgICAgTTksMTEgbDIsLTInIHN0cm9rZT0nI0JERTRGRicgc3Ryb2tlLXdpZHRoPScxJy8+Cjwvc3ZnPg==')
							.attr('x', 0)
							.attr('y', 0)
							.attr('width', 10)
							.attr('height', 10);
						d3.select('defs')
							.append('pattern')
							.attr('id', 'diagonal-stripe-green')
							.attr('patternUnits', 'userSpaceOnUse')
							.attr('width', 10)
							.attr('height', 10)
							.append('image')
							.attr('xlink:href', 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHdpZHRoPScxMCcgaGVpZ2h0PScxMCc+CiAgPHJlY3Qgd2lkdGg9JzEwJyBoZWlnaHQ9JzEwJyBmaWxsPScjOEZDRTQ2Jy8+CiAgPHBhdGggZD0nTS0xLDEgbDIsLTIKICAgICAgICAgICBNMCwxMCBsMTAsLTEwCiAgICAgICAgICAgTTksMTEgbDIsLTInIHN0cm9rZT0nI0MwRUI4RCcgc3Ryb2tlLXdpZHRoPScxJy8+Cjwvc3ZnPg==')
							.attr('x', 0)
							.attr('y', 0)
							.attr('width', 10)
							.attr('height', 10);
						d3.select('defs')
							.append('pattern')
							.attr('id', 'diagonal-stripe-magenta')
							.attr('patternUnits', 'userSpaceOnUse')
							.attr('width', 10)
							.attr('height', 10)
							.append('image')
							.attr('xlink:href', 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHdpZHRoPScxMCcgaGVpZ2h0PScxMCc+CiAgPHJlY3Qgd2lkdGg9JzEwJyBoZWlnaHQ9JzEwJyBmaWxsPScjRTIwNDgyJy8+CiAgPHBhdGggZD0nTS0xLDEgbDIsLTIKICAgICAgICAgICBNMCwxMCBsMTAsLTEwCiAgICAgICAgICAgTTksMTEgbDIsLTInIHN0cm9rZT0nI0ZGNUJBRScgc3Ryb2tlLXdpZHRoPScxJy8+Cjwvc3ZnPg==')
							.attr('x', 0)
							.attr('y', 0)
							.attr('width', 10)
							.attr('height', 10);
					};
				}

				function generateChart() {
					if (!scope.chartData) {
						return;
					}

					allowPatternFill();

					chartData = scope.chartData.projData;
					currency = scope.chartData.currency;
					var fyTargetValue = scope.chartData.fyTarget;
					var stretchTargetValue = scope.chartData.stretchTarget;
					var fyLines = [];
					var i;

					for (i = 0; i < chartData.length; i++) {
						if (chartData[i].hasOwnProperty('ldnaTargetValue')) {
							todayXValue = chartData[i].periodEndDate.getTime();
							break;
						}
					}

					showTargets = true;
					_.forEach(leanFilterService.activeFilters, function (value, key) {
						if ((value.name !== 'Site' && value.name !== 'Time Period' && value.name !== 'Business Unit' &&
								value.name !== 'Division' && value.name !== 'Entity' && value.name !== 'Item Type') && value.display !== 'All') {
							showTargets = false;
						}
					});
					var hasMyItemsActive = leanFilterService.myItemFilter.enabled && leanFilterService.myItemFilter.selected;
					var hasSearchEntry = !!leanFilterService.getSearchBoxDataValue() && leanFilterService.getSearchBoxDataValue().length;
					if (hasSearchEntry || hasMyItemsActive) {
						showTargets = false;
					}

					if (showTargets && fyTargetValue && fyTargetValue !== '0') {
						fyLines.push({
							value: fyTargetValue,
							class: 'fyTargetClass'
						});
					}
					if (showTargets && stretchTargetValue && stretchTargetValue !== '0') {
						fyLines.push({
							value: stretchTargetValue,
							class: 'stretchTargetClass'
						});
					}
					
					var config = {};
					config.bindto = '#' + elem[0].id;
					config.data = {};
					config.data.selection = {
						enabled: true,
						isselectable: function (d){
							return d.id === 'netOpportunity' || d.id === 'reductionResults' || d.id === 'lostOpportunity';
						}
					};

					var options = storeService.getState().reportSettings.config.options || {},
						startDate = getStartDateFromOptions(options, scope.defaultWeeksPast),
						endDate = getEndDateFromOptions(options, scope.defaultWeeksFuture);

					config.data.keys = {
						x: xAxisField,
						value: getDefaultKeys(options.interactiveHistory)
					};

					// If history lines are showing, add those to the list of keys
					for (i = 0; i < chartData.length; i++) {
						if (chartData[i].historyLdna || chartData[i].historyLdna === 0) {
							config.data.keys.value.splice(2, 0, 'historyMrp');
							config.data.keys.value.splice(2, 0, 'historyLdna');
							break;
						}
						var targetVal = chartData[i][targetFieldName] || chartData[i][targetFieldName] === 0 ? chartData[i][targetFieldName] : chartData[i][yAxisFieldName];
						var minValue = Math.min(chartData[i][yAxisFieldName], targetVal);
						var maxValue = Math.max(chartData[i][yAxisFieldName], targetVal);
						chartData[i].netOpportunity = maxValue - minValue;
						var lost = chartData[i].expiredValue
							//d3 max is undefined safe
							+ d3.max([chartData[i].unableToFixValue, 0])
							+ d3.max([chartData[i].excludedValue, 0])
							+ d3.max([chartData[i].unactionableValue, 0]);
						if (chartData[i][yAxisFieldName] >= targetVal) {
							chartData[i].reductionResults = chartData[i].fixedValue;
							chartData[i].lostOpportunity = lost;
						} else {
							chartData[i].reductionResultsTooltipOnly = chartData[i].fixedValue;
							chartData[i].lostOpportunityTooltipOnly = lost;
						}
						if (chartData[i].periodEndDate.getTime() >= scope.fromDate) {
							chartData[i].hiddenBar = minValue - (chartData[i].lostOpportunity && isV2 && !options.interactiveHistory ? chartData[i].lostOpportunity : 0);
							chartData[i].mrpPlusSavings = chartData[i][yAxisFieldName] + chartData[i].fixedValue;
							chartData[i].ldnaMinusLost = targetVal - lost;
						}
					}

					config.data.json = chartData;
					config.data.type = 'line';

					var types = {
						'ldnaTargetValue': 'line',
						'hiddenBar': 'bar',
						'netOpportunity': 'bar'
					};

					var v2Types = {
						'ldnaTargetValue': 'line',
						'hiddenBar': 'bar',
						'lostOpportunity': 'bar',
						'netOpportunity': 'bar',
						'reductionResults': 'bar',
						'mrpPlusSavings': 'line',
						'ldnaTargetMinusLost': 'line'
					};
					config.data.types = isV2 && !options.interactiveHistory ? v2Types : types;

					var v2Groups = [['hiddenBar', 'lostOpportunity', 'netOpportunity', 'reductionResults']];
					var groups = [['hiddenBar', 'netOpportunity']];
					config.data.groups = isV2 && !options.interactiveHistory ? v2Groups : groups;

					config.data.order = null;

					config.bar = {
						width: 11
					};
					config.line = {
						connectNull: true
					};
					config.point = {
						r: 5,
						focus: {
							expand: {
								r: 6.5
							}
						}
					};

					config.legend = {};
					config.legend.show = true;
					jQuery('rect.c3-legend-item-event').on('click', function () {});
					config.legend.item = {
						onclick: function (id) {
							// reimplement show/hide behavior
							chart.toggle(id);
							if (id === 'mrpPlusSavings') {
								chart.toggle('reductionResults');
							}
							// update config object because clicking history points recreates
							// the chart from the config
							var hideIndex = config.data.hide.indexOf(id);
							if (hideIndex !== -1) {
								config.data.hide.splice(hideIndex, 1);
							} else {
								config.data.hide.push(id);
							}
							// update range
							updateYAxisRange();

							// update visible data in reportSettings
							var visibleData = chart.data.shown();
							visibleDataNames = [];
							var i;
							for (i = visibleData.length - 1; i >= 0; i--) {
								visibleDataNames.push(visibleData[i].id);
							}

							// hide lostOpportunity with css instead of toggling
							// will shift netOpp and reductionResults otherwise
							if (id === 'ldnaMinusLost') {
								var includeLostOpportunityInHidden = visibleDataNames.indexOf('ldnaMinusLost') === -1;
								d3.selectAll('.c3-bars-lostOpportunity')
									.classed('hidden', includeLostOpportunityInHidden);
							}
						}
					};

					function updatePointDisplays(optionalPoint) {
						if (!options.interactiveHistory || optionalPoint) {
							var comparePoint = optionalPoint || todayXValue;
							d3.selectAll('.c3-shapes.c3-shapes-mrpValue .c3-circle')
								.filter(function (d) {
									return d.x && d.x.getTime() === comparePoint;
								})
								.style('display', 'inline')
								.style('r', 10)
								.style('stroke', colors.mrp)
								.style('stroke-width', '2px')
								.style('fill', 'white');
						} else {
							d3.selectAll('.c3-shapes.c3-shapes-mrpValue .c3-circle')
								.filter(function (d) {
									return d.x.getTime() < todayXValue;
								})
								.style('display', 'inline')
								.style('r', 5.5)
								.style('stroke', colors.mrp)
								.style('stroke-width', '1px')
								.style('fill', 'white');
						}
					}

					function clickDefaultHistoryPoint(startDate) {
						var mrpData = _.find(chart.data(), function (d) {
							return d.id === 'mrpValue';
						});
						if (!mrpData || !mrpData.values) {
							// no chart data
							return;
						}
						mrpData = mrpData.values;
						var today = new Date();
						var daysDifference = (today.getTime() - startDate.getTime()) / (1000 * 3600 * 24);
						// find today point in chart data
						var clickIndex = _.findIndex(mrpData, function (d) {
							return d.x.getTime() > today.getTime();
						}) - 1;
						if (daysDifference < 14) {
							clickIndex -= 1;
						} else if (daysDifference < 28) {
							clickIndex -= 2;
						} else { 
							clickIndex -= 4;
						}
						if (clickIndex < 0) {
							clickIndex = 0;
						}
						clickFunction(mrpData[clickIndex]);
					}

					function updateYAxisRange() {
						// update range
						var currentRange = chart.axis.range();
						var newRange = getMinMaxRange(chartData);
						currentRange.min.y = newRange.min;
						currentRange.max.y = newRange.max;
						chart.axis.range(currentRange);
						// redraw labels for targets
						addFYLabels();
						if (!scope.showExtraData) {
							jQuery('.c3-target-pastDueReqs').css('display', 'none');
						}
					}

					function updateLegend() {
						// change legend symbols and click behavior
						///////////////////////
						// Projected Inventory
						///////////////////////
						var legendEntry = d3.select('#burnoffChartCont > svg > g > g.c3-legend-item.c3-legend-item-ldnaTargetValue');
						var line = legendEntry.select('line');
						line.attr('stroke-width', 3);
						var x1 = line.attr('x1');
						var x2 = line.attr('x2');
						var y1 = line.attr('y1');

						var circle = legendEntry.select('circle');
						if (circle.size() === 0) {
							circle = legendEntry.append('circle');
						}
						circle.attr('cx', (parseFloat(x1) + parseFloat(x2)) / 2);
						circle.attr('cy', y1);
						circle.attr('r', '3');
						circle.style('fill', colors.ldna);

						///////////////////////
						// Potential Inventory
						///////////////////////
						legendEntry = d3.select('#burnoffChartCont > svg > g > g.c3-legend-item.c3-legend-item-mrpValue');
						line = legendEntry.select('line');
						line.attr('stroke-width', 3);
						x1 = line.attr('x1');
						x2 = line.attr('x2');
						y1 = line.attr('y1');

						circle = legendEntry.select('circle');
						if (circle.size() === 0) {
							circle = legendEntry.append('circle');
						}
						circle.attr('cx', (parseFloat(x1) + parseFloat(x2)) / 2);
						circle.attr('cy', y1);
						circle.attr('r', '3');
						circle.style('fill', colors.mrp);

						if (isV2 && !options.interactiveHistory) {
							///////////////////////
							// Reduction Results
							///////////////////////
							legendEntry = d3.select('#burnoffChartCont > svg > g > g.c3-legend-item.c3-legend-item-mrpPlusSavings');
							var tile = legendEntry.select('line.c3-legend-item-tile');
							x1 = tile.attr('x1');
							x2 = tile.attr('x2');
							y1 = tile.attr('y1');
							tile.attr('stroke-width', 8);

							// overlay another line so the color won't flicker when c3 redraws
							var tile2 = legendEntry.select('line.c3-legend-item-tile2');
							if (tile2.size() === 0) {
								tile2 = legendEntry.append('line');
								tile2.classed('c3-legend-item-tile2', true);
							}
							tile2.attr('stroke-width', 8);
							tile2.attr('x1', x1);
							tile2.attr('x2', x2);
							tile2.attr('y1', y1);
							tile2.attr('y2', y1);
							tile2.style('stroke', colors.reductionResults);

							// dashed orange line along the top
							var line2 = legendEntry.select('line.legend-dashed-line');
							if (line2.size() === 0) {
								line2 = legendEntry.append('line');
								line2.classed('legend-dashed-line', true);
							}
							line2.attr('x1', parseFloat(x1) - 4);
							line2.attr('x2', parseFloat(x2) + 3);
							line2.attr('y1', parseFloat(y1) - 5);
							line2.attr('y2', parseFloat(y1) - 5);
							line2.style('stroke', colors.mrp);
							line2.style('stroke-width', 3);
							line2.style('stroke-dasharray', '3 2');

							///////////////////////
							// Lost Opportunity
							///////////////////////
							legendEntry = d3.select('#burnoffChartCont > svg > g > g.c3-legend-item.c3-legend-item-ldnaMinusLost');
							tile = legendEntry.select('line.c3-legend-item-tile');
							x1 = tile.attr('x1');
							x2 = tile.attr('x2');
							y1 = tile.attr('y1');
							tile.attr('stroke-width', 8);

							// overlay another line so the color won't flicker when c3 redraws
							tile2 = legendEntry.select('line.c3-legend-item-tile2');
							if (tile2.size() === 0) {
								tile2 = legendEntry.append('line');
								tile2.classed('c3-legend-item-tile2', true);
							}
							tile2.attr('stroke-width', 8);
							tile2.attr('x1', x1);
							tile2.attr('x2', x2);
							tile2.attr('y1', y1);
							tile2.attr('y2', y1);
							tile2.style('stroke', colors.lostOpportunity);

							// dashed blue line along the bottom
							line2 = legendEntry.select('line.legend-dashed-line');
							if (line2.size() === 0) {
								line2 = legendEntry.append('line');
								line2.classed('legend-dashed-line', true);
							}
							line2.attr('x1', parseFloat(x1) - 4);
							line2.attr('x2', parseFloat(x2) + 3);
							line2.attr('y1', parseFloat(y1) + 5);
							line2.attr('y2', parseFloat(y1) + 5);
							line2.style('stroke', colors.ldna);
							line2.style('stroke-width', 3);
							line2.style('stroke-dasharray', '3 2');
						}
					}

					function clearHistoryLines() {
					// Remove existing history lines
						for (var i = chartData.length - 1; i >= 0; i--) {
							delete chartData[i].historyMrp;
							delete chartData[i].historyLdna;
							// If the only remaining property is the date, then remove the entire point
							if (Object.keys(chartData[i]).length <= 1) {
								chartData.splice(i, 1);
							}
						}
						for (var i = 0; i < config.data.keys.value.length; i++) {
							var value = config.data.keys.value[i];
							if (value === 'historyLdna' || value === 'historyMrp') {
							// Assumes they are neighbors in the keys array
								config.data.keys.value.splice(i, 2);
							}
						}
						hasHistoryLines = false;
					}

					function clickFunction(d) {
						var clickableData = ['mrpValue', 'netOpportunity', targetFieldName, 'reductionResults',
							'lostOpportunity', 'ldnaMinusLost', 'mrpPlusSavings'];
						if (clickableData.indexOf(d.id) === -1) {
							return;
						}
						var date = Date.parse(d.x);
						if (date >= scope.now - 1000 * 3600 * 24 || (isV2 && !options.interactiveHistory)) {
							// Point is too recent, no need to show history
							if (hasHistoryLines) {
								clearHistoryLines();
								chart = c3.generate(config);
								updateYAxisRange();
								if (isV2) {
									$timeout(updatePointDisplays, 100);
								}
								if (currentSelectedPoint) {
									$timeout(function () {
										centerBar({ index: currentSelectedPoint });
										var index = hasHistoryLines ? d.index : currentSelectedPoint;
										scope.$emit('showChartBar', { index: index });
									});
								}
							}
							if ($experiments.isEnabled('burnoff-v2') || d.x.getTime() > (new Date()).getTime()) {
								centerBar(d);
								openDetailsSlideIn(d);
							}
							return;
						}
						inventoryBurnoffService.getHistory(date).then(function (response) {
							if (hasHistoryLines) {
								clearHistoryLines();
							}
							if (!response || !response.data) {
								// error or no data
								chart = c3.generate(config);
								updateYAxisRange();
								if (isV2) {
									$timeout(updatePointDisplays, 100);
								}
								return;
							}
							addStartingDataPointToHistory(date);
							for (var i = 0; i < response.data.length; i++) {
								mergeHistoryToResults(response.data[i]);
							}
							config.data.keys.value = getDefaultKeys(true); // XXX For whatever reason, this config doesn't match the global one for keys
							config.data.keys.value.splice(2, 0, 'historyMrp');
							config.data.keys.value.splice(2, 0, 'historyLdna');
							// Get the date of the first week's end date.
							// The history was recorded 7 days before then
							var historyStartDate = new Date(response.data[0].periodEndDate);
							historyStartDate.setDate(historyStartDate.getDate() - 7);
							historyStartDateStr = $filter('date')(historyStartDate, 'shortDate', 'UTC');
							config.data.names['historyMrp'] = 'Projected Inventory as of ' + historyStartDateStr;
							config.data.names['historyLdna'] = 'Potential Inventory as of ' + historyStartDateStr;

							// unhide these
							var historyDataNames = ['historyMrp', 'historyLdna'];
							for (i = 0; i < historyDataNames.length; i++) {
								var hideIndex = config.data.hide.indexOf(historyDataNames[i]);
								if (hideIndex !== -1) {
									config.data.hide.splice(hideIndex, 1);
								}
							}

							var range = getMinMaxRange(chartData);
							config.axis.y.min = range.min;
							config.axis.y.max = range.max;
							mrpCounter = ldnaTargetCounter = -1;
							hasHistoryLines = true;
							chart = c3.generate(config);
							updateYAxisRange();
							if (isV2) {
								$timeout(function () {
									updatePointDisplays();
									updatePointDisplays(d.x.getTime());
								}, 100);
							}
						});
					}

					// hide some data based on the report config
					var dataToCheck = [yAxisFieldName, targetFieldName, 'pastDueReqs', 'ignoredValue'];
					var dataToHide = [];
					if (visibleDataNames) {
						for (var j = dataToCheck.length - 1; j >= 0; j--) {
							var dataName = dataToCheck[j];
							if (visibleDataNames.indexOf(dataName) === -1) {
								dataToHide.push(dataName);
							}
						}
					}
					config.legend.hide = ['hiddenBar', 'lostOpportunity', 'excludedActions', 'reductionResults',
						'unableToFixValue', 'expiredValue', 'netOpportunity', 'overTargetValue', 'underTargetValue',
						'lostOpportunityTooltipOnly', 'reductionResultsTooltipOnly'];
					if (!scope.showExtraData) {
						config.legend.hide.push('pastDueReqs');
					}
					config.data.hide = dataToHide;

					unsubscribeFromStore && unsubscribeFromStore();
					unsubscribeFromStore = storeService.subscribe(function () {
						var newActiveTab = storeService.getState().burnoffDrawer.activeTab;
						if (newActiveTab !== currentActiveTab) {
							// remove highlight/show-bar from old, add to new
							var newBarId = _.camelCase(newActiveTab);
							var oldBarId = _.camelCase(currentActiveTab);
							jQuery('.c3-bars-' + oldBarId + ' .c3-bar-' + currentBarIndex).removeClass('highlight');
							jQuery('.c3-bars-' + oldBarId + ' .c3-bar-' + currentBarIndex).removeClass('show-bar');
							jQuery('.c3-bars-' + newBarId + ' .c3-bar-' + currentBarIndex).addClass('highlight');
							jQuery('.c3-bars-' + newBarId + ' .c3-bar-' + currentBarIndex).addClass('show-bar');
							currentActiveTab = newActiveTab;
						}
						var newOptions = storeService.getState().reportSettings.config.options || {};
						if (options !== newOptions && (Object.keys(options).length !== 0 || Object.keys(newOptions).length !== 0)) {
							var needRedraw = false;
							if (options.interactiveHistory !== newOptions.interactiveHistory) {
								needRedraw = true;
							}
							options = newOptions;
							startDate = getStartDateFromOptions(options, scope.defaultWeeksPast);
							endDate = getEndDateFromOptions(options, scope.defaultWeeksFuture);
							if (config) {
								_.merge(config, { axis: { x: { min: startDate, max: endDate } } });
							}
							if (needRedraw) {
								if (!options.interactiveHistory) {
									clearHistoryLines();
								} else {
									clickDefaultHistoryPoint(startDate);
								}
								$timeout(resizeChart);
							} else {
								updateYAxisRange();
								if (chart) {
									var range = chart.axis.range();
									range.min.x = startDate;
									range.max.x = endDate;
									chart.axis.range(range);
								}
							}
						}
					});

					function xTickFormat(x) {
						var totalWeeks = (+options.past || scope.defaultWeeksPast || 26) + (+options.future || scope.defaultWeeksFuture || 26);
						var formatTicksAsMonths = totalWeeks >= 26 || (options && options.weeklyOrMonthly === 'MONTHLY');
						if (formatTicksAsMonths) {
							return $filter('date')(x, 'MMM yyyy', 'UTC');
						}
						return $filter('date')(x, 'mediumDate', 'UTC');
					}

					function centerBar(point) {
						currentSelectedPoint = !point.x ? point.index : _.findIndex(chartData, function (pt) {
							return pt.periodEndDate === point.x;
						});
						var slideInWidth = 650;
						var chartWidth = jQuery('#burnoffChartCont .c3-grid')[0].getBoundingClientRect().width;
						var newWidth = chartWidth - slideInWidth;
						var dateDifference = (endDate.getTime() - startDate.getTime()) / 1000 / 3600 / 24;
						var pixelsPerDay = chartWidth / dateDifference;
						var newPixelRightAnchor = newWidth - (newWidth * 0.10);
						var newRightDaysOffset = newPixelRightAnchor / pixelsPerDay;
						var newLeftDaysOffset = newWidth * 0.10 / pixelsPerDay;
						var currentLocationDaysOffset = (chartData[currentSelectedPoint][xAxisField].getTime() - startDate.getTime()) / 1000 / 3600 / 24;
						if (currentLocationDaysOffset < newLeftDaysOffset || currentLocationDaysOffset > newRightDaysOffset) {
							var daysShift = currentLocationDaysOffset < newLeftDaysOffset
								? currentLocationDaysOffset - newLeftDaysOffset 
								: currentLocationDaysOffset - newRightDaysOffset;
							startDate.setDate(startDate.getDate() + daysShift);
							endDate.setDate(endDate.getDate() + daysShift);
							setRangeFromOptions();
						}
					}

					function resetCenter() {
						currentSelectedPoint = undefined;
						startDate = getStartDateFromOptions(options, scope.defaultWeeksPast);
						endDate = getEndDateFromOptions(options, scope.defaultWeeksFuture);
						setRangeFromOptions();
					}

					function shiftPeriod(event, param) {
						var index = param.index + param.offset;
						if (index < 0 || index > chartData.length - 1) {
							return;
						}
						var newParam = {
							index: param.index + param.offset,
							barIndex: param.barIndex + (2 * param.offset),
							activeTab: param.activeTab,
							id: _.camelCase(param.activeTab)
						};
						centerBar(newParam);
						openDetailsSlideIn(newParam);
					}

					function setRangeFromOptions() {
						if (config) {
							_.merge(config, { axis: { x: { min: startDate, max: endDate } } });
						}
						var range = chart.axis.range();
						range.min.x = startDate;
						range.max.x = endDate;
						chart.axis.range(range);
					}

					scope.$on('resetCenter', resetCenter);
					scope.$on('shiftPeriod', shiftPeriod);

					var range = getMinMaxRange(chartData, dataToHide);
					config.axis = {};
					config.axis.x = {
						'type': 'timeseries',
						localtime: false,
						tick: {
							format: xTickFormat,
							outer: false,
							count: 38
							// rotate: 60
						},
						padding: {
							left: 7 * 24 * 60 * 60 * 1000
						},
						min: startDate,
						max: endDate
					};
					config.axis.y = {
						tick: {
							format: formatCurrency,
							count: 6
						},
						min: range.min,
						max: range.max,
						padding: {
							bottom: 20
						}
					};
					config.size = {};
					config.size.height = windowHeight;
					config.data.names = {};
					config.data.names[yAxisFieldName] = $translate.instant('Projected Inventory');
					config.data.names['mrpPlusSavings'] = $translate.instant('Reduction Results');
					config.data.names[targetFieldName] = $translate.instant('Potential Inventory');
					config.data.names['ldnaMinusLost'] = $translate.instant('Lost Opportunity');
					config.data.names[ignoredValueFieldName] = $translate.instant('Potential Inventory (no exclusions)');
					config.data.names['pastDueReqs'] = $translate.instant('Past Due Requirements');

					config.grid = {
						x: {
							show: false,
							lines: getXLines()
						},
						y: {
							lines: fyLines,
							show: true
						}
					};
					if (fyTargetValue || stretchTargetValue) {
						config.padding = {
							right: 100
						};
					}
					config.data.color = function (color, d) {
						if (d.id === 'historyMrp' || d === 'historyMrp') {
							return colors.historyMrp;
						} else if (d.id === 'historyLdna' || d === 'historyLdna') {
							return colors.historyLdna;
						} else if (d.id === 'pastDueReqs' || d === 'pastDueReqs') {
							return colors.pastDue;
						} else if (d.id === yAxisFieldName || d === yAxisFieldName || d.id === 'mrpPlusSavings') {
							return colors.mrp;
						} else if (d.id === targetFieldName || d === targetFieldName || d.id === 'ldnaMinusLost') {
							return colors.ldna;
						} else if (d.id === ignoredValueFieldName || d === ignoredValueFieldName) {
							return colors.ldna;
						} else if (d === yAxisFieldName) {
							return colors.ldna;
						} else if (d.id === 'hiddenBar') {
							return colors.hiddenBar;
						} else if (d.id === 'netOpportunity') {
							return colors.netOpportunity;
						} else if (d.id === 'reductionResults') {
							return colors.reductionResults;
						} else if (d.id === 'lostOpportunity') {
							return colors.lostOpportunity;
						}
					};
					config.data.colors = {};
					config.data.colors[yAxisFieldName] = colors.mrp;
					config.data.colors[targetFieldName] = colors.ldna;
					config.data.colors[ignoredValueFieldName] = colors.ldna;
					config.data.colors['historyLdna'] = colors.historyLdna;
					config.data.colors['historyMrp'] = colors.historyMrp;
					config.data.colors['pastDueReqs'] = colors.pastDue;
					config.data.colors['hiddenBar'] = colors.hiddenBar;
					config.data.colors['netOpportunity'] = colors.netOpportunity;
					config.data.colors['reductionResults'] = colors.reductionResults;
					config.data.colors['lostOpportunity'] = colors.lostOpportunity;
					config.data.colors['mrpPlusSavings'] = colors.mrp;
					config.data.colors['ldnaMinusLost'] = colors.ldna;
					config.data.labels = {
						format: labelFormat
					};
					config.onrendered = function () {
						$timeout(function () {
							addFYLabels();
							addDataLabelClasses();
						}, 0);
					};
					config.onresized = function () {
						if (chart) {
							chart.data.names({
								historyMrp: 'Projected Inventory as of ' + historyStartDateStr,
								historyLdna: 'Potential Inventory as of ' + historyStartDateStr
							});
							
							$timeout(updateLegend, 100);
						}
					};
					config.tooltip = {
						contents: tooltipFormat,
						position: getPosition
					};
					if (isV2) {
						var hoverableIds = ['reductionResults', 'lostOpportunity', 'netOpportunity'];
						config.data.onmouseover = function (d) {
							if (hoverableIds.indexOf(d.id) > -1) {
								jQuery('.c3-bars-' + d.id + ' .c3-bar-' + d.index).addClass('highlight');
							}
						};
						config.data.onmouseout = function (d) {
							if (jQuery('.c3-bars-' + d.id + ' .c3-bar-' + d.index).hasClass('show-bar')) {
								return;
							}
							jQuery('.c3-bars-' + d.id + ' .c3-bar-' + d.index).removeClass('highlight');
						};
					}
					config.data.onclick = clickFunction;
					chart = c3.generate(config);
					updateYAxisRange();
					updateLegend();
					if (isV2) {
						$timeout(updatePointDisplays, 100);
					}
				}

				var chartReady = false;
				var configReady = false;
				initListener = scope.$on('burnoffChartDataReady', function () {
					chartReady = true;
					if (configReady) {
						init();
					}
				});

				initListener2 = scope.$on('reportConfigReady', function () {
					configReady = true;
					if (chartReady) {
						init();
					}
				});

				scope.$on('$destroy', function () {
					unsubscribeFromStore && unsubscribeFromStore();
					chartReady = false;
					configReady = false;
					if (chart) {
						chart.destroy();
						chart = undefined;
					}
					jQuery('.embeddedBody').off('resize', resizeChart);
					jQuery('#navigation').unbind('leftNavChanged', resizeChart);

					if (initListener) {
						initListener();
						initListener2();
					}
				});
			}
		};
	}
})();
